import React, { useState } from 'react';
import { addEmailSignup } from '../lib/addEmailSignup';

interface EmailSignupProps {
  variant?: 'footer' | 'inline' | 'checkoutSuccess';
}

const EmailSignup: React.FC<EmailSignupProps> = ({ variant = 'footer' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('sending');
    try {
      await addEmailSignup(email);
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <p className="text-green-500 text-sm font-medium">
        Thanks! You’re on the list.
      </p>
    );
  }

  const formClass =
    variant === 'footer'
      ? 'flex flex-col sm:flex-row gap-2 max-w-md'
      : variant === 'checkoutSuccess'
      ? 'flex flex-col sm:flex-row gap-2'
      : 'space-y-2';

  const inputClass =
    variant === 'checkoutSuccess'
      ? 'flex-1 px-4 py-2 bg-black/40 border border-white/15 rounded-lg text-sm focus:outline-none focus:border-neon-blue disabled:opacity-50'
      : 'flex-1 px-4 py-2 bg-dark border border-white/10 rounded-lg text-sm focus:outline-none focus:border-neon-blue disabled:opacity-50';

  const buttonClass =
    variant === 'checkoutSuccess'
      ? 'px-4 py-2 rounded-lg border border-neon-blue/50 text-neon-blue hover:bg-neon-blue/10 text-sm font-medium disabled:opacity-50'
      : 'px-4 py-2 rounded-lg bg-neon-blue hover:bg-neon-blue/90 text-white text-sm font-medium disabled:opacity-50';

  return (
    <form onSubmit={handleSubmit} className={formClass}>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your@email.com"
        required
        disabled={status === 'sending'}
        className={inputClass}
      />
      <button
        type="submit"
        disabled={status === 'sending'}
        className={buttonClass}
      >
        {status === 'sending' ? 'Signing up…' : variant === 'checkoutSuccess' ? 'Subscribe' : 'Sign up'}
      </button>
      {status === 'error' && (
        <p className="text-red-500 text-xs">Something went wrong. Try again or email us.</p>
      )}
    </form>
  );
};

export default EmailSignup;
